@if (showDebugger) {
  <div class="debugger">
    <div class="debugger-select">
      <mat-form-field appearance="fill">
        <mat-label>Debugger</mat-label>
        <mat-select (selectionChange)="onDebuggerChange($event)" [(value)]="selectedDebugger">
          <mat-option [value]="DebuggerType.FEATURE_FLAG">Feature flag Debugger</mat-option>
          <mat-option [value]="DebuggerType.MEDIA">Media Debugger</mat-option>
          <mat-option [value]="DebuggerType.NETWORK">Network Debugger</mat-option>
          <mat-option [value]="DebuggerType.PEER_CONNECTION">Peer Connections Debugger</mat-option>
          <mat-option [value]="DebuggerType.SCREENSHARE">Screenshare Debugger</mat-option>
          <mat-option [value]="DebuggerType.PERFORMANCE">Performance Debugger</mat-option>
          <mat-option [value]="DebuggerType.ROOM_SETTINGS">Room Settings</mat-option>
          <mat-option [value]="DebuggerType.SCENE">Scene Debugger</mat-option>
          <mat-option [value]="DebuggerType.SOUND">Sound Debugger</mat-option>
          <mat-option [value]="DebuggerType.SUBSCRIPTION">Subscription Debugger</mat-option>
          <mat-option [value]="DebuggerType.TEST_UTILITIES">Test Utilities</mat-option>
          <mat-option [value]="DebuggerType.SPECIAL_ACCESS_GROUP">Special Access Groups</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="warn" (click)="min = !min">{{ min ? '+' : '-' }}</button>
    </div>
    <div [class.min]="min">
      @switch (selectedDebugger) {
        @case (DebuggerType.SUBSCRIPTION) {
          <app-debugger-subscriptions></app-debugger-subscriptions>
        }
        @case (DebuggerType.NETWORK) {
          <network-debugger></network-debugger>
        }
        @case (DebuggerType.SOUND) {
          <app-sound-debugger></app-sound-debugger>
        }
        @case (DebuggerType.PERFORMANCE) {
          <performance-debugger></performance-debugger>
        }
        @case (DebuggerType.MEDIA) {
          <media-debugger></media-debugger>
        }
        @case (DebuggerType.FEATURE_FLAG) {
          <feature-flag-debugger></feature-flag-debugger>
        }
        @case (DebuggerType.SCENE) {
          <scene-debugger></scene-debugger>
        }
        @case (DebuggerType.PEER_CONNECTION) {
          <peer-connection-debugger></peer-connection-debugger>
        }
        @case (DebuggerType.SCREENSHARE) {
          <app-debugger-screenshare></app-debugger-screenshare>
        }
        @case (DebuggerType.TEST_UTILITIES) {
          <test-utilities></test-utilities>
        }
        @case (DebuggerType.ROOM_SETTINGS) {
          <room-settings-debugger></room-settings-debugger>
        }
        @case (DebuggerType.SPECIAL_ACCESS_GROUP) {
          <app-sag-debugger></app-sag-debugger>
        }
      }
    </div>
  </div>
}
